import { FlowNodeTypeEnum } from '$/domains/node/type';
import type { FileType } from '$/utils/upload';

export interface CommunityInfoResponse {
  audit_id: string;
  audit_status: number;
  audit_remark: string;
  client_id: number;
  client_status: number;
  community_id: string;
  cover: string;
  created_at: number;
  data: string;
  description: string;
  name: string;
  room_id: string;
  self_room_id: string;
  show: number;
  uid: number;
  updated_at: number;
  used_num: string;
  canvas_data: string;
  cover_media: Array<{
    url: string;
    cover: string;
    type: 'video' | 'image' | 'audio';
  }>;
  example_media: Array<{
    url: string;
    cover: string;
    type: 'video' | 'image' | 'audio';
  }>;
  user: {
    avatar: string;
    screen_name: string;
    uid: string;
  };
}

export interface SubmitMediaItem {
  url: string;
  type: FileType;
}

export interface InputMediaNode {
  id: string;
  type: FlowNodeTypeEnum;
  data: Record<string, any>;
}

export interface CommunitySubmitParams {
  name: string;
  description: string;
  room_id: string;
  canvas_data: string;
  data: string;
  cover_media: SubmitMediaItem[];
  example_media: SubmitMediaItem[];
}
export interface CommunityCategoryItem {
  category_id: number | string;
  name: string;
  iconfont: string;
}

export enum AuditStatus {
  Auditing = 1,
  Resolved = 2,
  Rejected = 3,
}

export interface CommunityCardItem {
  community_id: number;
  room_id: string;
  from_room_id: string;
  audit_status: AuditStatus;
  used_num: string;
  name: string;
  description: string;
  cover_media: Array<{
    url: string;
    type: 'image' | 'video' | 'audio';
  }>;
  user: {
    uid: number;
    avatar: string;
    screen_name: string;
  };
}
